package org.example.project.enginechat

import androidx.compose.runtime.Composable
import androidx.compose.runtime.key
import org.example.project.dashboard.ContentOffset
import org.example.project.dashboard.PopupEngineCard
import org.example.project.service.CRChatPopupService

@Composable
fun CRChatPopupOverlayLayer(node: String) {
    val popups = CRChatPopupService.getPopups(node)

    popups.forEachIndexed { index, popup ->
        PopupEngineCard(
            windowKey = "cr-chat-${popup.id}",
            widthPx = 520,
            heightPx = 360,
            minWidthPx = 240,
            minHeightPx = 180,
            initialX = 320.0 + ((index % 4) * 28.0),
            initialY = 160.0 + ((index % 4) * 22.0),
            contentInsetLeft = ContentOffset.LEFT.value.toDouble(),
            contentInsetTop = ContentOffset.TOP.value.toDouble(),
            contentInsetRight = ContentOffset.RIGHT.value.toDouble(),
            contentInsetBottom = ContentOffset.BOTTOM.value.toDouble(),
            onClose = { CRChatPopupService.closePopup(node, popup.id) }
        ) {
            key(popup.id) {
                CRChatPanel(
                    cr = popup,
                    embeddedInEngine = true,
                    onClose = { CRChatPopupService.closePopup(node, popup.id) }
                )
            }
        }
    }
}
